import {IHttpProvider, IRequestConfig} from "angular";
import {Konfigurasjon} from "./Konfigurasjon";
import {Bygginformasjon} from "./Bygginformasjon";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import {UiRouterFasade} from "./UiRouterFasade";
import {KlientinformasjonFraUserAgent} from "../tjenester/KlientinformasjonFraUserAgent";
import IInjectorService = angular.auto.IInjectorService;
import {registrerStandardRequestHeadere, StandardRequestHeadereHttpInterceptorAvhengigheter} from "felles/infrastruktur/StandardRequestHeadereInterceptorAvhengigheter";

declare const device: any;

/**
 * Legger til faste headdere i alle requester med info om kallende klient.
 */
export function registrerStandardRequestHeadereInterceptor(
  $httpProvider: IHttpProvider,
  konfigurasjon: Konfigurasjon,
  bygginformasjon: Bygginformasjon) {

    var requestInterceptor = ($injector: IInjectorService) => {
        return {
            request: (reqKonfig: IRequestConfig) => {
                //kan ikke injisere $state i requestInterceptor da vi får "Circular dependency" error
                //fordi registrerStandardRequestHeadereInterceptorForInjisering() kalles via angular.module.config(..)

                registrerHeadere($injector, konfigurasjon, bygginformasjon, (navn, verdi) => reqKonfig.headers[navn] = verdi);

                return reqKonfig;
            }
        }
    };

    $httpProvider.interceptors.push([regNavn.ng.$injector, requestInterceptor]);
}

/**
 * Registrerer standard headere som serverside benytter ifbm logging
 *
 * ########################################################################
 * MERK - DERSOM DU LEGGER TIL HEADERE HER MÅ DISSE OGSÅ LEGGES TIL I
 * no.systemfabrikken.lederplan.infrastruktur.filter.LPCrossOriginFilter
 * ########################################################################
 */
export function registrerHeadere($injector: angular.auto.IInjectorService, konfigurasjon: Konfigurasjon, bygginformasjon: Bygginformasjon, registrerHeader: (navn, verdi) => void) {
    try {
        const klientinformasjon = <KlientinformasjonFraUserAgent>$injector.get(KlientinformasjonFraUserAgent.regNavn);
        const uiRouter = <UiRouterFasade>$injector.get(UiRouterFasade.regNavn);
        const avhengigheter = new StandardRequestHeadereHttpInterceptorAvhengigheter(konfigurasjon, bygginformasjon, klientinformasjon, uiRouter)

        registrerStandardRequestHeadere(
          avhengigheter.statiskInformasjon(),
          avhengigheter.kallInformasjon(),
          registrerHeader
        );

    } catch (e) {
        console.error("Feil under registrering av standard http headere", e);
    }
}

export function registrerStandardRequestHeadereInterceptorForInjisering() {
    return [
        regNavn.ng.$httpProvider,
        Konfigurasjon.regNavn,
        Bygginformasjon.regNavn,
        registrerStandardRequestHeadereInterceptor
    ];
}

//hjelpemetoder
